import checkboxActive from "./checkbox-active.svg";
import ringOutlined from "./ring-outlined.svg";
import radioActive from "./radio-active.svg";
import fries from "./fries.svg";

export default {
  fries,
  radioActive,
  ringOutlined,
  checkboxActive,
};
